import {Component, OnInit} from '@angular/core';
import { ReportService } from './report.service';
import 'rxjs' ;
import { saveAs } from 'file-saver';


@Component({
    templateUrl: './ui-report.component.html',
    styleUrls: ['./ui-report.component.css', '../home/welcome.component.css']

})
export class UIReortComponent implements OnInit {
    pageTitle: string = 'UI Report';
    errorMessage: string;
    report: any;
    date: Date;
    dateOf: any;
    pageCount: number;  // no of pages
    pageNumber: number[] = []; // page number array e,g: 1,2,3,4,5
    currentPage: number = 1;
    i: number;
    dateUtc: string[] = [];
    pageSize: string;
    pageNum: number;
    totalRecords: any = 0;
    private headers: Headers;
    constructor(private _reportService: ReportService) {
        this.report = [];
        this.report.totalRecords = 0;
        this.dateOf = function(date) {
            date = date.replace('-', ' ');
            date = date.replace('-', ' ');
            date = date.replace(':', ' ');
            date = date.replace(':', ' ');
            this.dateUtc = date.split(' ');
            const utcDate1 = new Date(Date.UTC(this.dateUtc[0], this.dateUtc[1] - 1, this.dateUtc[2],
                                 this.dateUtc[3], this.dateUtc[4], this.dateUtc[5]));
            return utcDate1.toUTCString();
        };
        window.onbeforeunload = function() {
            window.location.href = '/';
        };
    }
    loadReport(event, num: number) {
        const target = event.target || event.srcElement || event.currentTarget;
        const idAttr = target.attributes.id;
        const value = idAttr.nodeValue;
        this.currentPage = num;
        this._reportService.getProducts(num.toString())
            .subscribe(report => {
                this.report = report.salesFileData;
                this.report.totalRecords = report.totalRecords;
            },
            error => this.errorMessage = <any>error);
        for (this.i = 1; this.i < 6; this.i++) {
        document.getElementById('page-num-' + this.i).className =
        document.getElementById('page-num-' + this.i).className
        .replace(new RegExp('(?:^|\\s)' + 'active-anchor' + '(?:\\s|$)'), ' ');
        }
        event.target.classList.add('active-anchor');
    }
    getReport(id: any, type: string, fileName: any) {
        this._reportService.getReports(id , type)
            .subscribe(data => {
                const blob = new Blob([data], { type: 'text/csv' });
                saveAs(blob , fileName + `.csv`);
                },
                        error => this.errorMessage = <any>error);
    }
    getDownload(id: any, fileName: any) {
    this._reportService.getDownloads(id)
    .subscribe(data => {
    const blob = new Blob([data], { type: 'text/csv' });
                saveAs(blob , fileName + `.csv`);
                },
        error => this.errorMessage = <any>error);
    }
    PreviousClick(pageNum: any) {
        if (this.currentPage === 1) {
            return true;
        } else {
        return false;
    }
    }
    NextClick(pageNum: any) {
        if (this.currentPage === this.pageCount) {
                return true;
        } else {
            return false;
        }
    }
    previousClickAction(pageNo: any) {
        if (this.currentPage <= this.pageCount) {
        if (pageNo[0] === this.currentPage) {
        this.pageNumber = [];
        this.i = 1;
        for (this.i = 0; this.i < 5; this.i++) {
            pageNo[this.i] = pageNo[this.i] - 1;
            this.pageNumber.push(pageNo[this.i]);
            this.pageNum = (pageNo[this.i] - 4);
        }
        for (this.i = 1; this.i < 6; this.i++) {
            document.getElementById('page-num-' + this.i).className =
            document.getElementById('page-num-' + this.i).className
            .replace(new RegExp('(?:^|\\s)' + 'active-anchor' + '(?:\\s|$)'), ' ');
            }
        this._reportService.getProducts(this.pageNum.toString())
            .subscribe(report => {
                this.report = report.salesFileData;
               this.report.totalRecords = report.totalRecords;
            },
            error => this.errorMessage = <any>error);
        } else {
            this._reportService.getProducts((this.currentPage - 1).toString())
            .subscribe(report => {
                this.report = report.salesFileData;
               this.report.totalRecords = report.totalRecords;
            },
            error => this.errorMessage = <any>error);
        }
        this.currentPage = this.currentPage - 1;
    }
    }
    nextClickAction(pageNo: any) {
         if (pageNo[4] === this.currentPage) {
        this.pageNumber = [];
        this.i = 1;
        for (this.i = 0; this.i < 5; this.i++) {
            pageNo[this.i] = pageNo[this.i] + 1;
            this.pageNumber.push(pageNo[this.i]);
            this.pageNum = (pageNo[this.i]);
        }
        for (this.i = 1; this.i < 6; this.i++) {
            document.getElementById('page-num-' + this.i).className =
            document.getElementById('page-num-' + this.i).className
            .replace(new RegExp('(?:^|\\s)' + 'active-anchor' + '(?:\\s|$)'), ' ');
            }
        this._reportService.getProducts(this.pageNum.toString())
            .subscribe(report => {
                this.report = report.salesFileData;
                this.report.totalRecords = report.totalRecords;
            },
            error => this.errorMessage = <any>error);
        } else {
            this._reportService.getProducts((this.currentPage + 1).toString())
            .subscribe(report => {
                this.report = report.salesFileData;
               this.report.totalRecords = report.totalRecords;
            },
            error => this.errorMessage = <any>error);
        }
        this.currentPage = this.currentPage + 1;
    }
    returnPageNum() {
        return this.currentPage;
    }
    ngOnInit() {
        this._reportService.getProducts('1')
            .subscribe(report => {
                this.report = report.salesFileData;
                this.report.totalRecords = 0;
                this.report.totalRecords = report.totalRecords;
                if (report.totalRecords % 10 > 0) {
                this.pageCount = Math.trunc(report.totalRecords / 10 + 1);
                } else {
                    this.pageCount = report.totalRecords / 10;
                }
                if (this.pageCount < 6) {
                for (this.i = 1; this.i < this.pageCount + 1; this.i++) {
                    this.pageNumber.push(this.i);
                }
            } else {
                for (this.i = 1; this.i < 6; this.i++) {
                    this.pageNumber.push(this.i);
                }
            }
            },
            error => this.errorMessage = <any>error);
    }
}
